document.addEventListener("DOMContentLoaded", function(){
  "use strict";

  var nav = document.getElementById("site-nav");
  if(nav){
    window.addEventListener("scroll",function(){
      nav.classList.toggle("scrolled", window.scrollY > 60);
    });
  }

  var burger = document.getElementById("burgerBtn");
  var navLinks = document.getElementById("navLinks");
if(burger && navLinks){
  burger.addEventListener("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    var isOpen = navLinks.classList.contains("open");
    if(isOpen){
      burger.classList.remove("open");
      navLinks.classList.remove("open");
    } else {
      burger.classList.add("open");
      navLinks.classList.add("open");
    }
  });
  navLinks.querySelectorAll("a").forEach(function(link){
    link.addEventListener("click", function(){
      burger.classList.remove("open");
      navLinks.classList.remove("open");
    });
  });
}

  var hero = document.querySelector(".hero");
  if(hero){
    for(var n=0;n<28;n++){
      var s = document.createElement("span");
      s.className = "sparkle";
      s.textContent = "✦";
      s.style.left = (Math.random()*96+2)+"%";
      s.style.top  = (Math.random()*80+5)+"%";
      s.style.fontSize = (7+Math.random()*13)+"px";
      s.style.animationDelay = (Math.random()*4)+"s";
      s.style.animationDuration = (3+Math.random()*3)+"s";
      hero.appendChild(s);
    }
  }

  if("IntersectionObserver" in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add("in"); io.unobserve(en.target); }
      });
    },{threshold:.12});
    document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function(el){ el.classList.add("in"); });
  }

  var toastTimer;
  function showToast(msg){
    var t = document.getElementById("toast");
    if(!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove("show"); }, 2800);
  }

  document.querySelectorAll(".quick-add-form").forEach(function(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var btn = form.querySelector("button");
      var originalText = btn.textContent;
      btn.textContent = "Aggiungo…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: form.querySelector("input[name='id']").value,
          quantity: 1
        })
      }).then(function(res){
        if(res.ok){
          showToast("Aggiunto al carrello ✦");
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const el = document.getElementById('cart-count');
              if (el) el.textContent = cart.item_count;
            });
        } else {
          showToast("Prodotto non disponibile");
        }
        btn.textContent = originalText;
      }).catch(function(){
        btn.textContent = originalText;
        showToast("Errore, riprova");
      });
    });
  });

  document.querySelectorAll(".product-thumbs .thumb").forEach(function(thumb){
    thumb.addEventListener("click", function(){
      var mainImg = document.querySelector(".product-page-img > img");
      if(mainImg) mainImg.src = thumb.getAttribute("data-full");
    });
  });

});
